import React, {useEffect, useState} from 'react';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import {Modal} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { dhl_real_order } from '../../../Context/actions';
import { dhl_delete_order } from '../../../Context/actions';
import { dhl_saklar_api } from '../../../Context/actions';
import { resi_fwx_dhl } from '../../../Context/actions';
import ReactPaginate from "react-paginate";


import Header_admin from '../../../Layout/Header_admin';
import Footer_admin from '../../../Layout/Footer_admin';

import LoadingBar from 'react-top-loading-bar';

import 'jquery/dist/jquery.min.js';
 
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery';

function Order() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const history = useHistory();

    const [orderCodeDhl, setOrderCodeDhl] = useState();
    const [shipmentInfoServiceType, setShipmentInfoServiceType] = useState();
    const [shipmentInfoCurrency, setShipmentInfoCurrency] = useState();
    const [shipmentInfoPaymentInfo, setShipmentInfoPaymentInfo] = useState();
    const [commoditiesNumberOfPieces, setCommoditiesNumberOfPieces] = useState();
    const [commoditiesDescription, setCommoditiesDescription] = useState();
    const [commoditiesCom, setCommoditiesCom] = useState();
    const [commoditiesQuantity, setCommoditiesQuantity] = useState();
    const [commoditiesUnitPrice, setCommoditiesUnitPrice] = useState();
    const [commoditiesCustomValue, setCommoditiesCustomValue] = useState();
    const [recipientName, setRecipientName] = useState();
    const [recipientCompany, setRecipientCompany] = useState();
    const [recipientPhone, setRecipientPhone] = useState();
    const [recipientEmail, setRecipientEmail] = useState();
    const [recipientAddress, setRecipientAddress] = useState();
    const [recipientPostalCode, setRecipientPostalCode] = useState();
    const [recipientCountry, setRecipientCountry] = useState();
    const [recipientCity, setRecipientCity] = useState();
    const [shipperName, setShipperName] = useState();
    const [shipperCompany, setShipperCompany] = useState();
    const [shipperPhone, setShipperPhone] = useState();
    const [shipperEmail, setShipperEmail] = useState();
    const [shipperAddress, setShipperAddress] = useState();
    const [shipperPostalCode, setShipperPostalCode] = useState();
    const [shipperCountry, setShipperCountry] = useState();
    const [shipperCity, setShipperCity] = useState();
    const [exportDeclarationInvoiceNumber, setExportDeclarationInvoiceNumber] = useState();
    const [exportDeclarationDestinationPort, setExportDeclarationDestinationPort] = useState();
  const [createdDate, setCreatedDate] = useState();

  const [page, setPage] = useState(1);
  const [awal, setAwal] = useState();
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState("");


  const [order, setOrder] = useState([]);
  const [statusApiOrder, setStatusApiOrder] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingApi, setLoadingApi] = useState(false);
  const [loadingCari, setLoadingCari] = useState(false);
  const [loadingResetPencarian, setLoadingResetPencarian] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingResi, setLoadingResi] = useState(false);
  const [loadingCreateOrder, setLoadingCreateOrder] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setLoading(true);
    const statusApiFetch = async () => {
      const res = await fetch(
        'https://athaexpress.net/backend/ongkir/api/checkApiOrderDhl',
      );
      const json = await res.json();
     
      if(json.status == "true"){
        setStatusApiOrder(json.data);
      }else{
        setStatusApiOrder("-");
      }
      
    };
    statusApiFetch();
    
  },[]);

  // useEffect(() => {
  //   setLoading(true);
  //   const fetchData = async () => {
  //     const res = await fetch(
  //       'https://athaexpress.net/backend/ongkir/api/showOrderLocalDhl/'+localStorage.getItem('username'),
  //     );
  //     const json = await res.json();
     
  //     if(json.status == "true"){
  //       setLoading(false);
  //       setOrder(json.data);
  //     }else{
  //       setLoading(false);
  //       setOrder("Data Tidak Tersedia");
  //     }
      
  //   };
  //   fetchData();
    
  // },[]);

  useEffect(() => {
      let url;
      const fetchData = async () => {
      if(query == ''){
          url = 'https://athaexpress.net/backend/ongkir/api/showDhlOrderGetDataPagination/'+localStorage.getItem('username');
          const res = await fetch(
              url,
          );
          const json = await res.json();
          
          
          if(json.status == "true"){
              setPage(page);
              setPages(json.pages);
              setRows(json.rows);
          }
          
          };

          
      }

      fetchData();
  }, [page, keyword]);

  useEffect(() => {
      let url;
      setProgress(progress + 40);
      setLoading(true);
      if(query == ''){
        
          if(awal == undefined){
              url = 'https://athaexpress.net/backend/ongkir/api/showDhlOrderPagination/0/'+localStorage.getItem('username');
          }else{
              url = 'https://athaexpress.net/backend/ongkir/api/showDhlOrderPagination/'+awal+'/'+localStorage.getItem('username');
          }

          const fetchData = async () => {
          const res = await fetch(
              url,
          );
          const json = await res.json();
          
          if(json.status == "true"){
            setProgress(100);
            setLoading(false);
            setOrder(json.data);
          }else{
            setProgress(100);
            setLoading(false);
          }
          
          };
          fetchData();
      }
    },[]);

  const changePage = ({ selected }) => {
      setProgress(progress + 40);
      if(query == ''){
          setPage(selected+1);
          
          let awal;
          
          awal = (Number((selected+1)+'0') - 10)

          setAwal(awal);

          const fetchData = async () => {
          const res = await fetch(
              'https://athaexpress.net/backend/ongkir/api/showDhlOrderPagination/'+awal+'/'+localStorage.getItem('username'),
          );
          const json = await res.json();
          
          if(json.status == "true"){
              setProgress(100);
              setOrder([]);
              setOrder(json.data);
          }else{
              setProgress(100);
              setMsg(
                  "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
              );
          }
          
          };
          fetchData();
      }else{
          setPage(selected+1);
          let awal;
          
          awal = (Number((selected+1)+'0') - 10)

          setAwal(awal);
          
          const fetchData = async () => {
          const res = await fetch(
              'https://athaexpress.net/backend/ongkir/api/showDhlOrderPaginationSearch/'+awal+'/'+query+'/'+localStorage.getItem('username'),
          );
          const json = await res.json();
          
          if(json.status == "true"){
              setProgress(100);
              setOrder([]);
              setOrder(json.data);
              
              setPages(json.pages);
              setRows(json.rows);
          }else{
              setProgress(100);
              setMsg(
                  "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
              );
          }
          
          };
          fetchData();
      }
      
  };

  function searchData(){
      setProgress(progress + 40);
      setLoadingCari(true);
      const fetchData = async () => { 
      const res = await fetch(
          'https://athaexpress.net/backend/ongkir/api/showDhlOrderPaginationSearch/0/'+query+'/'+localStorage.getItem('username'),
      );
      const json = await res.json();
      
      if(json.status == "true"){
          setLoadingCari(false);
          setProgress(100);
          setOrder([]);
          setPages(0);
          setRows(0);
          setPage(1);
          setOrder(json.data);
          setPages(json.pages);
          setRows(json.rows);
          
      }else{
          setLoadingCari(false);
          setProgress(100);
          setOrder(json.data);
          setPages(json.pages);
          setRows(json.rows);
          setMsg(
              "Data yang anda cari tidak di temukan. Pencarian ini berdasarkan Nama Penerima !"
          );
      }
      
      };
      fetchData(); 
  }; 

  function resetPencarian(){
    setLoadingResetPencarian(true)
    setQuery("");
    setTimeout(
        function() {
          setLoadingResetPencarian(false)
          window.location.reload(true);
        }
        ,
        2000
    );
  }

  useEffect(() => {
    
    setTimeout(()=>{
      $("#example2").DataTable({
        destroy: true,
        "info": false,
        fixedColumns: true,
        //dom: "rBftlip",
        // buttons: [
        //   {
  
        //   },
        // ],
        lengthMenu: [
          [10, 20, 50, 100, -1],
          [10, 20, 50, 100, "All"],
        ],
        pageLength: 10,
    });
  
    
    },1000)

    
}, [])

  function onoff(){
    if(localStorage.getItem('username') == 'superuser'){
      const promise_login = Promise.resolve(dhl_saklar_api());
      setProgress(progress + 40);
      setLoadingApi(true)
      promise_login.then((value) => {
          if(value.hasil == '1'){
              setProgress(100);
              setLoadingApi(false)
              alert(value.message);
              history.push('/dhl_order');
              window.location.reload(true);
          }else if(value.hasil == '2'){
              setProgress(100);
              setLoadingApi(false)
              alert('Pesan Dari DHL : '+ value.message);
              history.push('/dhl_order');
              window.location.reload(true);
          }
      });
      
    }else{
      alert('Mohon maaf user anda tidak berwenang untuk aktif API');
    }
  }

  function resi_dhl(id){
    if(id == '0'){
      alert('Resi Tidak Tersedia');
    }else{
      setLoadingResi(true);
      setProgress(progress + 40);
      setTimeout(
          function() {
            setLoadingResi(false);
            setProgress(100);
            window.open(id);
          }
          ,
          2000
      );
    }
  }

  function resi_fastworld(id,status){
    setProgress(progress + 40);
    setLoadingResi(true);
    const promise_login = Promise.resolve(resi_fwx_dhl(base64_encode(id)));

    promise_login.then((value) => {
        if(value.hasil == '1'){
            setProgress(100);
            setLoadingResi(false);
            window.open(value.message);
        }
    });
  }

  
  function edit_order(id){
    history.push('/dhl_edit_order?orderCodeDhl='+base64_encode(id));
  }

  
  function delete_order_onclick(id){
    if (window.confirm('Are you sure you want to delete this ?')) {
      setProgress(progress + 40);
      setLoading(true)
      const promise_login = Promise.resolve(dhl_delete_order(id));

        promise_login.then((value) => {
            if(value.hasil == '1'){
                setProgress(100);
                setLoading(false)
                alert(value.message);
                history.push('/dhl_order');
                window.location.reload(true);
            }else if(value.hasil == '2'){
                setProgress(100);
                setLoading(false)
                alert(value.message);
                history.push('/dhl_order');
                window.location.reload(true);
            }
        });
        
    } else {
    }
  }

  function create_order(orderCodeDhl){
    if (window.confirm('Harap Periksa Data Terlebih Dahulu Sebelum Create Order !!!!!')) {
      setProgress(progress + 40);
      setLoadingCreateOrder(true)
      const promise_login = Promise.resolve(dhl_real_order(orderCodeDhl));

        promise_login.then((value) => {
            if(value.hasil == '1'){
                setProgress(100);
                setLoadingCreateOrder(false)
                alert("Order DHL Berhasil");
                history.push('/dhl_order');
                window.location.reload(true);
            }else if(value.hasil == '2'){
                setProgress(100);
                setLoadingCreateOrder(false)
                alert(JSON.stringify(value.error_message, null, 2).replace(/\\/g, ''));
                history.push('/dhl_order');
                window.location.reload(true);
            }else if(value.hasil == '3'){
                setProgress(100);
                setLoadingCreateOrder(false)
                alert(value.error_message);
                history.push('/dhl_order');
                window.location.reload(true);
            }else{
              setProgress(100);
              setLoadingCreateOrder(false)
            }
        });
    } else {
    }
  }


  return (
      <div>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header_admin></Header_admin>
    <main id="main" class="main">

      <div class="pagetitle">
        <h1>Data Order DHL&nbsp; <img src={require('../../../assets_landingpage/img/dhl_icon.png')} alt="Profile" width="70px" height="50px" class="rounded-circle" /></h1>
        &nbsp;
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
            <li class="breadcrumb-item active">Order</li>
          </ol>
        </nav>
      </div>

      <section class="section">
        <div class="row">
        <div class="col-lg-2">
            <button className="button_tambah_item" onClick={(e) => {
                e.preventDefault();
                window.location.href='/dhl_add_order';
                }}>
              <i className="fa fa-plus"
                style={{ marginRight: "5px" }}
              />
              &nbsp;
              Add Order
            </button>
        </div>
        <div class="col-lg-4">
        Status API DHL : {statusApiOrder == "1" ? ("Nyala"):("Mati")} &nbsp;&nbsp;&nbsp;&nbsp;
            {
              statusApiOrder == "1" ? (
                <button type="button" className="button_api_off" disabled={loadingApi} onClick={() => onoff()}>
                  {statusApiOrder == "1" ? 
                    
                      loadingApi ? 
                      (<div>
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                        Matikan
                      </div>)
                      :
                      (<div>
                        <i
                        className="fa fa-power-off"
                        style={{ marginRight: "5px" }}
                      />
                      Matikan
                      </div>)
                    
                    :
                    loadingApi ? 
                      (<div>
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                        Nyalakan
                      </div>)
                      :
                      (<div>
                        <i
                        className="fa fa-power-off"
                        style={{ marginRight: "5px" }}
                      />
                      Nyalakan
                      </div>)
                  }
                </button>
                )
                :
                (
                <button type="button" className="button_api_on" disabled={loadingApi} onClick={() => onoff()}>
                  {statusApiOrder == "1" ? 
                    loadingApi ? 
                    (<div>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                      Matikan
                    </div>)
                    :
                    (<div>
                      <i
                      className="fa fa-power-off"
                      style={{ marginRight: "5px" }}
                    />
                    Matikan
                    </div>)
                    :
                    loadingApi ? 
                      (<div>
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                        Nyalakan
                      </div>)
                      :
                      (
                        <div>
                          <i
                          className="fa fa-power-off"
                          style={{ marginRight: "5px" }}
                        />
                        Nyalakan
                        </div>
                      )
                    }
                </button>
                )
            }
        </div>
        <div class="col-md-6 d-flex flex-row-reverse">
            <form class="form-inline">
            <input
              type="text"
              className="form-control"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Cari sesuatu disini..."
            />
            &nbsp;
            <button type="button" onClick={searchData} className="button_cari" disabled={loadingCari}>
              {loadingCari ? (
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ marginRight: "5px" }}
                />
              ):
              (<i
                className="fa fa-search"
                style={{ marginRight: "5px" }}
              />)}
              {loadingCari && <span>Cari</span>}
              {!loadingCari && <span>Cari</span>}
            </button>
            &nbsp;
            <button type="button" onClick={resetPencarian} className="button_reset_pencarian" disabled={loadingResetPencarian}>
              {loadingResetPencarian ? (
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ marginRight: "5px" }}
                />
              ):
              (<i
                className="fa fa-refresh"
                style={{ marginRight: "5px" }}
              />)}
              {loadingResetPencarian && <span>Reset Pencarian</span>}
              {!loadingResetPencarian && <span>Reset Pencarian</span>}
            </button>
            </form>
        </div>
        </div>
        <br />
        <div class="row"> 
          <div class="col-lg-12">
          <table class="table table-hover table-bordered">
            <thead>
              <tr align="center">
                <th>OrderCode</th>
                <th>Detail</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
            {
              order != 'Data Tidak Tersedia' ?
              order.map(item => (
                
                  <tr>
                    <td>{item.orderCodeDhl}</td>
                    <td>
                      <button type="button" class="button_detail" 
                        onClick={() => {
                          setOrderCodeDhl(item.orderCodeDhl);
                          setShipperName(item.shipperName);
                          setShipperCompany(item.shipperCompany);
                          setShipperPhone(item.shipperPhone);
                          setShipperEmail(item.shipperEmail);
                          setShipperAddress(item.shipperAddress);
                          setShipperCity(item.shipperCity);
                          setShipperPostalCode(item.shipperPostalCode);
                          setShipperCountry(item.shipperCountryName);
                          setRecipientName(item.recipientName);
                          setRecipientCompany(item.recipientCompany);
                          setRecipientPhone(item.recipientPhone);
                          setRecipientEmail(item.recipientEmail);
                          setRecipientAddress(item.recipientAddress);
                          setRecipientCity(item.recipientCity);
                          setRecipientPostalCode(item.recipientPostalCode);
                          setRecipientCountry(item.recipientCountryName);
                          setCreatedDate(item.created_date);
                          setShow(true);
                        }}>
                            {loadingDetail ? (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            ):
                            (<i
                              className="fa fa-search"
                              style={{ marginRight: "5px" }}
                            />)}
                            {loadingDetail && <span>Detail</span>}
                            {!loadingDetail && <span>Detail</span>}
                        </button>
                    </td>
                    <td>
                      {
                        item.flag_status == '1' ? (
                        <div><img src={require('../../../assets_landingpage/img/silang.png')} width="30px" height="30px" alt="" />&nbsp;&nbsp;&nbsp;<button type="button" onClick={() => create_order(base64_encode(item.orderCodeDhl))} className="button_create_order" disabled={loadingCreateOrder}>
                          {loadingCreateOrder ? (
                            <i
                              className="fa fa-refresh fa-spin"
                              style={{ marginRight: "5px" }}
                            />
                          ):
                          (<i
                            className="fa fa-send"
                            style={{ marginRight: "5px" }}
                          />)}
                          {loadingCreateOrder && <span>Create Order</span>}
                          {!loadingCreateOrder && <span>Create Order</span>}  
                        </button></div>)
                        :
                        (
                          <div>
                            <img src={require('../../../assets_landingpage/img/ceklist.png')} width="30px" height="30px" alt="" />
                            &nbsp;&nbsp;&nbsp;
                            <button type="button" className="button_resi_provider" disabled={loadingResi} onClick={() => resi_dhl(item.resi_dhl_perpaket)}>
                              {loadingResi ? (
                                <i
                                  className="fa fa-refresh fa-spin"
                                  style={{ marginRight: "5px" }}
                                />
                              ):
                              (<i
                                className="fa fa-paperclip"
                                style={{ marginRight: "5px" }}
                              />)}
                              {loadingResi && <span>Resi Tracking</span>}
                              {!loadingResi && <span>Resi Tracking</span>}
                            </button>
                            &nbsp;
                            <button type="button" className="button_resi_provider" disabled={loadingResi} onClick={() => resi_dhl(item.resi_dhl_commercial)}>
                              {loadingResi ? (
                                <i
                                  className="fa fa-refresh fa-spin"
                                  style={{ marginRight: "5px" }}
                                />
                              ):
                              (<i
                                className="fa fa-paperclip"
                                style={{ marginRight: "5px" }}
                              />)}
                              {loadingResi && <span>Resi Commercial</span>}
                              {!loadingResi && <span>Resi Commercial</span>}
                            </button>
                            &nbsp;
                            {
                              <button type="button" className="button_resi_fastworld" disabled={loadingResi} onClick={() => resi_fastworld(item.orderCodeDhl,0)}>
                                {loadingResi ? (
                                  <i
                                    className="fa fa-refresh fa-spin"
                                    style={{ marginRight: "5px" }}
                                  />
                                ):
                                (<i
                                  className="fa fa-paperclip"
                                  style={{ marginRight: "5px" }}
                                />)}
                                {loadingResi && <span>Resi Fastworld</span>}
                                {!loadingResi && <span>Resi Fastworld</span>}
                              </button>
                            }
                            
                          </div>
                        )
                      }
                      
                    </td>
                    <td>
                      <div class="w3-show-inline-block">
                        <div class="w3-bar">
                          <button type="button" className="button_edit" disabled={loading} onClick={() => edit_order(item.orderCodeDhl)}>
                            {loading ? (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            ):
                            (<i
                              className="fa fa-edit"
                              style={{ marginRight: "5px" }}
                            />)}
                            {loading && <span>Edit</span>}
                            {!loading && <span>Edit</span>}
                          </button>&nbsp;
                          <button type="button" class="button_hapus" disabled={loading} onClick={() => delete_order_onclick(item.orderCodeDhl)}>
                            {loading ? (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            ):
                            (<i
                              className="fa fa-times-circle"
                              style={{ marginRight: "5px" }}
                            />)}
                            {loading && <span>Hapus</span>}
                            {!loading && <span>Hapus</span>}
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
                :
                <tr>
                  <td colSpan={3}>Data Tidak Tersedia</td>
                </tr>
            }
            </tbody>
          </table>
          <p>
              Total Rows: {rows} Page: {page} of {pages}
          </p>
          <p className="has-text-centered has-text-danger">{msg}</p>

          <div id="container">
              <ReactPaginate
                  previousLabel={"< Prev"}
                  nextLabel={"Next >"}
                  pageCount={pages}
                  onPageChange={changePage}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  containerClassName={'pagination'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  previousClassName={'page-item'}
                  previousLinkClassName={'page-link'}
                  nextClassName={'page-item'}
                  nextLinkClassName={'page-link'}
                  activeClassName={'active'}
              />
          </div>
          </div>
        </div>
      </section>

    </main>
    <Modal size="lg" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Data Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <form class="row g-3 needs-validation" novalidate>
        <div class="row">
          <div class="col-12">
            <label for="lTrackingNumber" class="form-label">Order Code</label>
            <div class="input-group has-validation">
              <input type="text" name="account" id="account" class="form-control" value={orderCodeDhl} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Created Date</label>
            <div class="input-group has-validation">
              <input type="date" name="created_date" id="created_date" class="form-control" value={createdDate} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Shipper Name</label>
            <div class="input-group has-validation">
              <input type="text" name="shipper_name" id="shipper_name" class="form-control" value={shipperName} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Shipper Company</label>
            <div class="input-group has-validation">
              <input type="text" name="shipper_company" id="shipper_company" class="form-control" value={shipperCompany} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Shipper Phone</label>
            <div class="input-group has-validation">
              <input type="text" name="shipper_phone" id="shipper_phone" class="form-control" value={shipperPhone} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Shipper Email</label>
            <div class="input-group has-validation">
              <input type="text" name="shipper_email" id="shipper_email" class="form-control" value={shipperEmail} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Shipper Address</label>
            <div class="input-group has-validation">
              <input type="text" name="shipper_address" id="shipper_address" class="form-control" value={shipperAddress} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Shipper City</label>
            <div class="input-group has-validation">
              <input type="text" name="shipper_city" id="shipper_city" class="form-control" value={shipperCity} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Shipper Postalcode</label>
            <div class="input-group has-validation">
              <input type="text" name="shipper_postalcode" id="shipper_postalcode" class="form-control" value={shipperPostalCode} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Shipper Country</label>
            <div class="input-group has-validation">
              <input type="text" name="shipper_countrycode" id="shipper_countrycode" class="form-control" value={shipperCountry} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Recipient Name</label>
            <div class="input-group has-validation">
              <input type="text" name="consignee_name" id="consignee_name" class="form-control" value={recipientName} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Recipient Company</label>
            <div class="input-group has-validation">
              <input type="text" name="consignee_company" id="consignee_company" class="form-control" value={recipientCompany} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Recipient Phone</label>
            <div class="input-group has-validation">
              <input type="text" name="consignee_phone" id="consignee_phone" class="form-control" value={recipientPhone} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Recipient Email</label>
            <div class="input-group has-validation">
              <input type="text" name="consignee_email" id="consignee_email" class="form-control" value={recipientEmail} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Recipient Address</label>
            <div class="input-group has-validation">
              <input type="text" name="consignee_address" id="consignee_address" class="form-control" value={recipientAddress} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Recipient City</label>
            <div class="input-group has-validation">
              <input type="text" name="consignee_city" id="consignee_city" class="form-control" value={recipientCity} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Recipient Postalcode</label>
            <div class="input-group has-validation">
              <input type="text" name="consignee_postalcode" id="consignee_postalcode" class="form-control" value={recipientPostalCode} required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="lLength" class="form-label">Recipient Country</label>
            <div class="input-group has-validation">
              <input type="text" name="consignee_countrycode" id="consignee_countrycode" class="form-control" value={recipientCountry} required />
            </div>
          </div>
        </div>
      </form>
      </Modal.Body>
    </Modal>
    <Footer_admin></Footer_admin>
      </div>
  );
}

export default Order;